<template>
  <el-col :lg="24">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t("orcamento") }}</span>
        <el-button-group style="float: right">
          <el-button
            @click="$router.push({ name: 'budget.import' })"
            icon="el-icon-upload2"
            >Arquivo</el-button
          >
        </el-button-group>
      </div>
      <el-collapse v-model="activeNames">
        <el-collapse-item title="Filtro" name="1">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            position="right"
          >
            <el-row :gutter="5">
              <el-col :lg="6">
                <el-form-item :label="$t('cep-origem')" prop="name">
                  <el-input ref="name" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="6">
                <el-form-item :label="$t('cep-destino')" prop="name">
                  <el-input ref="name" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="6">
                <el-form-item :label="$t('peso')" prop="name">
                  <el-input ref="name" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="6">
                <el-form-item :label="$t('formato')" prop="name">
                  <el-select v-model="value" placeholder="Select">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :lg="8">
                <el-form-item :label="$t('altura')" prop="name">
                  <el-input ref="name" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8">
                <el-form-item :label="$t('largura')" prop="name">
                  <el-input ref="name" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8">
                <el-form-item :label="$t('comprimento')" prop="name">
                  <el-input ref="name" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :lg="20">
                <el-form-item :label="$t('servico')" prop="name">
                  <el-select
                    v-model="services"
                    multiple
                    filterable
                    placeholder="Select"
                  >
                    <el-option
                      v-for="item in tableService"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="2">
                <el-button>
                  <i class="el-icon-search"></i>
                  Pesquisar
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <el-table
        :data="tablePost"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'deadline', order: 'ascending' }"
      >
        <el-table-column sortable prop="service" :label="$t('servico')">
          <template slot-scope="scope">
            <el-button type="text">{{ scope.row.service }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Tipo"></el-table-column>
        <el-table-column sortable prop="price" label="Preço">
          <template slot-scope="scope">
            <el-button type="text">{{ scope.row.price }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="deadline" :label="$t('prazo')"></el-table-column>
      </el-table>
      <div class="bottom clearfix">
        <el-row :gutter="5">
          <el-col :lg="10">
            <el-pagination
              layout="prev, pager, next"
              :total="1"
            ></el-pagination>
          </el-col>
          <el-col :lg="3" style="margin-top: 2px; float: right">
            <el-dropdown>
              <el-button>
                Exportar
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <download-excel :data="tablePost"> XLS </download-excel>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { BudgetService } from "@/services/budget/budget.services.js";
import { i18n } from "@/plugin/i18n";
export default {
  name: "BudgetList",
  data() {
    return {
      services: [],
      tablePost: [],
      ruleForm: {
        start: "",
      },
    };
  },
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      BudgetService.list()
        .then((response) => {
          this.tablePost = response.records.map((val) => {
            return {
              service: val.code,
              price: val.price,
              name: val.name,
              deadline: val.delivery,
            };
          });
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    this.fetchRecords();
  },
};
</script>

<style>
</style>